var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { H4 } from '../../headers';
import { InformationBoxStyles } from './InformationBoxStyles';
export var InformationBox = function (props) {
    return (_jsxs(InformationBoxStyles, __assign({ className: props.className, background: props.background, icon: props.icon }, { children: [_jsxs("div", __assign({ className: "primary-container" }, { children: [_jsx(_Fragment, { children: props.icon && props.icon }), _jsx(H4, __assign({ className: "header" }, { children: props.primaryText }))] })), props.secondaryText && _jsx("div", __assign({ className: "secondary-container" }, { children: props.secondaryText }))] })));
};
